// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loop-circle[data-v-5b58b0b7]{--animation-duration:0.65s;transform-origin:24px 24px;animation:loop-circle-anim-data-v-5b58b0b7 var(--animation-duration) infinite cubic-bezier(.645,.045,.355,1)}@keyframes loop-circle-anim-data-v-5b58b0b7{0%{transform:rotate(0)}to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;
